import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, VisuallyHidden } from '@chakra-ui/react';
import { SpinnerIcon } from './SpinnerIcon';
export const Spinner = ({ speed = '2.5s', color = 'inherit', label = 'Loading...', fontSize = '1rem', ...flexProps }) => {
    return (_jsxs(Flex, { color: color, align: "center", ...flexProps, children: [label && _jsx(VisuallyHidden, { children: label }), _jsx(SpinnerIcon, { speed: speed, fontSize: fontSize })] }));
};
